import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { AutenticacionService } from './autenticacion.service';
import {PoliticaPerfil} from '../_models/politica-perfil';
import {PoliticaOficina} from '../_models/politica-oficina';
import {PoliticaDescarteOficina} from '../_models/politica-descarte-oficina';

@Injectable({
  providedIn: "root",
})
export class PoliticasDescarteOficinaService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasDescartesOficinas";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listadoPoliticaOficina() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as PoliticaDescarteOficina[]));
  }

  listadoPoliticaOficinaHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticaDescarteOficina[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as PoliticaDescarteOficina));
  }

  listadoIdPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaDescarteOficina[]));
  }

  listadoIdPoliticaEnabled(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica + "/enabled" )
      .pipe(map((res) => res as PoliticaDescarteOficina[]));
  }

  crear(regCrear: PoliticaDescarteOficina) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticaDescarteOficina));
  }

  actualizar(regActualizar: PoliticaDescarteOficina) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticaDescarteOficina));
  }

  bulk(registros: PoliticaDescarteOficina[]) {
    registros.map((s: PoliticaDescarteOficina) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", registros)
      .pipe(map((res) => res as PoliticaDescarteOficina[]));
  }
}
